import Choices from "choices.js";
import { useRef } from "react";

import { useTranslation } from "@/lib/i18n";
import { LegacyWidgetConfiguration } from "@/lib/api";
import { LegacyProducts } from "@/types/widget";
import { HTMLTextContainer } from "@/features/shared/widgets/components";
import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";
import { Html } from "@/components/html/html";

import { LWC } from "./lwc";
import "choices.js/public/assets/styles/choices.min.css";

const isRenderableHtmlString = (value: unknown): value is string =>
  typeof value === "string";

const HtmlWidget = ({
  id,
  data,
  configuration,
}: {
  id: string;
  data: unknown;
  configuration?: LegacyWidgetConfiguration;
}) => {
  const { t } = useTranslation();
  useRefetchWidget(id);

  const htmlRef = useRef<HTMLDivElement>(null);

  if (!isRenderableHtmlString(data)) {
    return (
      <HTMLTextContainer content={t("widgets.html.structured_data_instead_of_html")} />
    );
  }

  if (configuration?.sub_type === LegacyProducts.OPMET) {
    // init choices.js if content is opmet form
    setTimeout(() => {
      if (htmlRef.current) {
        const dropdowns = htmlRef.current.querySelectorAll(
          "select[data-choices]:not(.choices__input)",
        );
        dropdowns.forEach((element) => {
          const choices = new Choices(element, {
            searchResultLimit: 12,
            shouldSort: false,
            fuseOptions: {
              threshold: 0.1,
              ignoreLocation: true,
              findAllMatches: true,
              isCaseSensitive: false,
            },
            searchFields: ["label", "value"],
          });
          if (element.getAttribute("data-choices-data")) {
            const dataChoices = JSON.parse(
              element.getAttribute("data-choices-data") ?? "[]",
            );
            choices.setChoices(dataChoices);
          }
        });
      }
    }, 50);
  }

  if (
    (configuration?.settings as { filename?: string })?.filename === "/data_os/ns/LWC.html"
  ) {
    return <LWC data={data} />;
  }

  return <Html content={data} ref={htmlRef} />;
};

export default HtmlWidget;
